import { render, staticRenderFns } from "./CIconBadge.vue?vue&type=template&id=b7c0d998&scoped=true&"
import script from "./CIconBadge.vue?vue&type=script&lang=js&"
export * from "./CIconBadge.vue?vue&type=script&lang=js&"
import style0 from "./CIconBadge.vue?vue&type=style&index=0&id=b7c0d998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c0d998",
  null
  
)

export default component.exports